import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import CourseRating from "../models/course-rating.model";
import * as firebase from "firebase/app";
import "firebase/firestore";
import { environment } from "../../environments/environment";
import { NotificationService } from "./notifications.service";

@Injectable({
  providedIn: "root",
})
export class CourseRatingService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/courses";
  ratingsRef: AngularFirestoreCollection<CourseRating>;

  constructor(
    private db: AngularFirestore,
    private userStore: UserService,
    private notiService: NotificationService
  ) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      this.userLogin = user;
    });
  }

  getRatings(courseId: string): AngularFirestoreCollection<CourseRating> {
    return this.db.collection(this.dbPath + `/${courseId}/ratings`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .orderBy("createdOn", "desc")
    );
  }

  getFirst(courseId: string, limit): any {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${courseId}/ratings`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .orderBy("createdOn", "desc")
      .limit(limit);

    return ref.get();
  }

  getMore(courseId: string, limit, cursor): any {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${courseId}/ratings`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .orderBy("createdOn", "desc")
      .limit(limit)
      .startAfter(cursor);

    return ref.get();
  }

  getCurrentRatings(courseId: string, uid: string): any {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${courseId}/ratings`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("createdBy", "==", uid)
      .orderBy("createdOn", "desc")
      .limit(1);

    return ref.get();
  }

  getMyRatings(
    courseId: string,
    uid: string
  ): AngularFirestoreCollection<CourseRating> {
    return this.db.collection(this.dbPath + `/${courseId}/ratings`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("createdBy", "==", uid)
        .orderBy("createdOn", "desc")
        .limit(50)
    );
  }

  getRating(courseId: string, id: string) {
    this.ratingsRef = this.db.collection(this.dbPath + `/${courseId}/ratings`);
    return this.ratingsRef.doc(id).valueChanges();
  }

  createRating(rating: CourseRating): any {
    rating.isActive = true;
    rating.isDeleted = false;
    rating.createdOn = new Date();
    rating.createdBy = this.userLogin.uid;

    rating.author = this.userLogin;
    rating.visibility = this.visibility;

    this.ratingsRef = this.db.collection(
      this.dbPath + `/${rating.courseId}/ratings`
    );

    return this.ratingsRef.add({ ...rating }).then((docRef) => {
      rating.id = docRef.id;

      //Send notification to tutor
      this.notiService.create(
        "Đánh giá",
        `/courses/${rating.courseId}/ratings`,
        rating.id,
        rating.courseId,
        `${rating.rating}* : ${rating.title}`,
        `${rating.refTitle}`,
        rating.toUid,
        `/tutor/courses/${rating.courseId}`,
        rating.courseId
      );

      return docRef.id;
    });
  }

  deleteRating(courseId: string, id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;

    this.ratingsRef = this.db.collection(this.dbPath + `/${courseId}/ratings`);

    return this.ratingsRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
    });
  }
}
